export default __webpack_public_path__ + "static/media/warningicon.534a8ff7.svg";